import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RapportIncidentTypeIncident } from 'src/api/models';

@Component({
  selector: 'app-rapport-incident-type',
  templateUrl: './rapport-incident-type.component.html',
  styleUrls: ['./rapport-incident-type.component.css']
})
export class RapportIncidentTypeComponent implements OnInit {
  @Input() public id: number;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  GetRapportIncidentType(t: RapportIncidentTypeIncident) {
    if (t === undefined || t == null) {
      return '';
    } else {
      return this.translateService.instant('Rapports.RapportsIncidents.TypesIncidents.' + RapportIncidentTypeIncident[t]);
    }
  } 
}
